import { Pagination, Stack } from '@mui/material';

const CustomPagination = (props) => {
  const handleChange = (_, pageNum) => {
    props?.handlePageChange(pageNum);
  };

  return (
    <Stack spacing={3}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Pagination
			showFirstButton
			showLastButton
			onChange={handleChange}
			page={props?.pageNo + 1} 
			count={props?.totalPages || Math.ceil((props?.totalRecords || 0) / (props?.pageSize || 10))}
		/>

        <span
          style={{
            marginLeft: '1rem',
            fontWeight: 600,
            fontSize: '.875rem',
            fontStyle: 'normal',
            fontFamily: 'Arial, Helvetica, sans-serif',
          }}
        >
          {`Page ${props?.pageNo + 1} of ${props?.totalPages}`}
        </span>
      </div>
    </Stack>
  );
};

export default CustomPagination;
